import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { ConfigProvider, App as AntdApp } from 'antd';
import { CitadeloLightTheme, CitadeloDarkTheme } from './theme/citadeloTheme';

// Theme
import { ThemeProvider, useTheme } from './hooks/useTheme';

// Authentication
import { AuthProvider } from './hooks/useAuth';
import { ProtectedRoute } from './pages/auth/ProtectedRoute';
import { Login } from './pages/auth/Login';
import { MFASetup } from './pages/auth/MFASetup';

// Client pages
import { ProjectList } from './pages/client/ProjectList';
import { ProjectChecklistForm } from './pages/client/ProjectChecklistForm';
import { ProjectFeedbackForm } from './pages/client/ProjectFeedbackForm';
import { ProjectRetestForm } from './pages/client/ProjectRetestForm';
import { ProjectStatus } from './pages/client/ProjectStatus';
import { DistributionManagement } from './pages/client/DistributionManagement';
import { MyProfile } from './pages/profile/MyProfile';

// Wizard pages
import { ProjectOnboardingWizard } from './pages/wizard/ProjectOnboardingWizard';

// Theme-aware wrapper component
const ThemedApp: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { isDarkMode } = useTheme();
  const currentTheme = isDarkMode ? CitadeloDarkTheme : CitadeloLightTheme;

  return (
    <ConfigProvider theme={currentTheme}>
      <AntdApp>
        {children}
      </AntdApp>
    </ConfigProvider>
  );
};

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <ThemedApp>
          <BrowserRouter>
            <Routes>
              {/* Public routes */}
              <Route path="/login" element={<Login />} />
            <Route path="/mfa-setup" element={<MFASetup />} />
            
            {/* Protected routes */}
            <Route path="/" element={
              <ProtectedRoute>
                <ProjectList />
              </ProtectedRoute>
            } />
            <Route path="/profile" element={
              <ProtectedRoute>
                <MyProfile />
              </ProtectedRoute>
            } />
            <Route path="/projects" element={
              <ProtectedRoute>
                <ProjectList />
              </ProtectedRoute>
            } />
            <Route path="/project/:projectId/checklist" element={
              <ProtectedRoute>
                <ProjectChecklistForm />
              </ProtectedRoute>
            } />
            <Route path="/project/:projectId/feedback" element={
              <ProtectedRoute>
                <ProjectFeedbackForm />
              </ProtectedRoute>
            } />
            <Route path="/project/:projectId/retest" element={
              <ProtectedRoute>
                <ProjectRetestForm />
              </ProtectedRoute>
            } />
            <Route path="/project/:projectId/status" element={
              <ProtectedRoute>
                <ProjectStatus />
              </ProtectedRoute>
            } />
            <Route path="/project/:projectId/distribution" element={
              <ProtectedRoute>
                <DistributionManagement />
              </ProtectedRoute>
            } />
            <Route path="/wizard/:token" element={
              <ProtectedRoute>
                <ProjectOnboardingWizard />
              </ProtectedRoute>
            } />
            </Routes>
          </BrowserRouter>
        </ThemedApp>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;